import { SortOrder } from './common.enums';

export interface SpecialistSearchCriteria {
  specialistIds: number[];
  notAssigned: boolean;
}

export interface PointOfContactSearchCriteria {
  pointOfContactIds: number[];
  notAssigned: boolean;
}

export interface DashboardSorting {
  property: string;
  order: SortOrder;
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  userName?: string;
  email: string;
  title: string;
  phoneNumbers?: PhoneNumber[];
  isActive?: boolean;
  employeeLevel?: string;
}

export interface PhoneNumber {
  type: string;
  number: string;
}

export enum DashboardFeature {
  Undefined ='Undefined',
  IncludeTotalCount ='IncludeTotalCount',
  IncludeFacets = 'IncludeFacets',
  None='None',
  IncludeItemCount ='IncludeItemCount',
  ShowUpcomingEvents = 'ShowUpcomingEvents'
}

export enum StatusColor {
  Yellow = 'yellow',
  Green = 'green',
  Grey = 'grey',
  Red = 'red'
}

export class FloorsCriteria {
  constructor() {
    this.floorUniqueKeys = [];
  }
  any: boolean;
  floorUniqueKeys: number[];
}

export class BuildingsCriteria {
  constructor() {
    this.floorsCriteria = new FloorsCriteria();
  }
  buildingId: number;
  floorsCriteria: FloorsCriteria
}

export class LocationFilterData {
  constructor() {
    this.buildingsCriteria = [];
    this.buildingIds = [];
    this.floorIds = [];
  }
  buildingIds: number[];
  floorIds: number[];
  buildingsCriteria: BuildingsCriteria[];
  public static selectedBuildingsAndFloors: any[];
}
